import NextHead from 'next/head'
import React from 'react'

type GoogleShoppingHeadProps = {
  structuredData: object
}

const GoogleShoppingHead: React.FC<GoogleShoppingHeadProps> = ({
  structuredData
}) => {
  return (
    <NextHead>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </NextHead>
  )
}

export default GoogleShoppingHead
